<template>
  <erp-s-field
      :view="this.fieldView || 'tl'"
      :label="label || 'Status'"
      :label-width="labelWidth"
      :helper="helper"
      :error="error"
      :no-label="noLabel"
      :helper-position="helperPosition || 'lb'"
  >
    <erp-select
        @input="__set"
        :loading="loading"
        :placeholder="placeholder || 'Selecione'"
        :options="asyncdata"
        v-model="model"
        :multiple="multiple"
        :simpleBorder="simpleBorder"
        :size="size || '1'"
    ></erp-select>
  </erp-s-field>
</template>

<script>
import SelectMixin from '../../../../mixins/SelectMixin'
import {tiposStatus as list} from '../../../../domain/tarefas/services'

export default {
  name: 'StatusTaskSelect',
  mixins: [SelectMixin],
  props: {
    codeAsValue: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      asyncdata: []
    }
  },
  computed: {},
  mounted () {
    this.load()
  },
  components: {},
  methods: {
    load () {
      this.loading = true
      list()
        .then((response) => {
          this.loading = false
          if (!Array.isArray(response.data.result)) {
            return
          }
          let list = response.data.result.map((obj) => {
            return {
              ...obj,
              label: obj.name,
              value: this.codeAsValue ? obj.code : obj.id
            }
          })

          !this.multiple && !this.required && list.unshift({label: this.placeholder || 'Selecione', value: null})
          this.asyncdata = list

          if (this.selectFirst) {
            this.$nextTick(() => {
              this.__emit(list[0].value)
            })
          }
        })
        .catch((error) => {
          this.loading = false

        })
    }
  }
}
</script>
